<div id="myDiv" #div>
  <canvas
    id="myCanvas"
    #canvas
    aria-label="image of the ship journal, which is written in the original language"
  ></canvas>
  <!-- <canvas id="offscreenCanvas" #canvas style="display: none"></canvas> -->
</div>
